import React, { useEffect, useState } from 'react';
import ProjectSearchInput from './ProjectSearchInput';
import { useQuery } from '@tanstack/react-query';
import {
  searchProjectNumbersFromAllProjects,
  searchProjectNumberSuggestions,
} from '../../services/api';
import LoadingOverlay from '../LoadingOverlay';
import { SuggestionForBusinessReport } from '../../types/search/SuggestionForBusinessReport';

interface ProjectNumberSearchProps {
  onSearch: (item: SuggestionForBusinessReport) => void;
  /** 編集時の初期表示（例: "250001"）。未指定なら空表示 */
  initialQuery?: string;
  /** 入力が空にされた時に通知したい場合（任意） */
  onClear?: () => void;
  /** ログインユーザーの参画プロジェクトのみを検索対象とするかどうか（デフォルトは true） */
  userProjectsOnly?: boolean;
}

const ProjectNumberSearch = ({
  onSearch,
  initialQuery = '',
  onClear,
  userProjectsOnly = true,
}: ProjectNumberSearchProps) => {
  const [query, setQuery] = useState(initialQuery);

  // 親から初期値/変更が来たら反映
  useEffect(() => {
    setQuery(initialQuery);
  }, [initialQuery]);

  const {
    data: results = [],
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['project-number-suggest', query],
    queryFn: () =>
      userProjectsOnly
        ? searchProjectNumberSuggestions(query)
        : searchProjectNumbersFromAllProjects(query),
    enabled: false, // 自動実行オフ
  });

  const runSearch = async (currentValue: string) => {
    const q = currentValue.replace(/\s+/g, ''); // 空白除去
    setQuery(q);
    if (!q) return;
    await refetch();
  };

  return (
    <>
      <LoadingOverlay isLoading={isLoading} isMutating={false} />
      <ProjectSearchInput
        value={query}
        onChange={(e) => {
          const v = e.target.value;
          setQuery(v);
          if (v.trim() === '') onClear?.();
        }}
        suggestions={results}
        onSelect={(item) => {
          setQuery(item.projectNumber);
          onSearch(item);
        }}
        onEnter={runSearch}
        placeholder="PJ Noを指定"
      />
      {error && (
        <div className="small text-danger mt-1">
          検索候補の取得に失敗しました
        </div>
      )}
    </>
  );
};

export default ProjectNumberSearch;
